export const links = {
  sage: 'https://sagerealestate.ca/',
  facebook: 'https://www.facebook.com/SageRealEstate/',
  instagram: 'https://www.instagram.com/SageRealEstate/',
}
